import request from '@/sheep/request';

// 自律项
export interface LimitProjects {
	id : number
	categoryId ?: number
	categoryName ?: string
	name ?: string
	icon ?: string
	description ?: string
	dailyLimit ?: number
	sort ?: number
	isShow ?: boolean
	status ?: number
	createTime ?: any
}

// 创建自律项
export const createLimitProjects = async (data : Partial<LimitProjects>) => {
	return request({
		url: '/wish/limit-projects/create',
		method: 'POST',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '创建成功'
		},
	});
}

// 更新自律项
export const updateLimitProjects = async (data : Partial<LimitProjects>) => {
	return request({
		url: '/wish/limit-projects/update',
		method: 'PUT',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '更新成功'
		},
	});
}

// 删除自律项
export const deleteLimitProjects = async (id : number) => {
	return request({
		url: '/wish/limit-projects/delete',
		method: 'DELETE',
		params: { id },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 批量删除自律项
export const deleteLimitProjectsList = async (ids : number[]) => {
	return request({
		url: '/wish/limit-projects/delete-list',
		method: 'DELETE',
		params: { ids },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 获得自律项
export const getLimitProjects = async (id : number) => {
	return request({
		url: '/wish/limit-projects/get',
		method: 'GET',
		params: { id },
		custom: {
			auth: false
		},
	});
}

// 获得自律项分页
export const getLimitProjectsPage = async (params : any) => {
	return request({
		url: '/wish/limit-projects/page',
		method: 'GET',
		params,
		custom: {
			auth: false
		},
	});
}

// 获得自律项列表
export const getLimitProjectsList = async (params : any) => {
	return request({
		url: '/wish/limit-projects/list',
		method: 'GET',
		params,
		custom: {
			auth: false
		},
	});
}

// 批量更新自律项排序和权重
export const batchUpdateLimitProjectsSortWeight = async (list : Partial<LimitProjects>[]) => {
	return request({
		url: '/wish/limit-projects/batch-update-sort-weight',
		method: 'PUT',
		data: list,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '排序更新成功'
		},
	});
}